module.exports = __webpack_public_path__ + "img/zhibotop.6706dcd3.png";